import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5abda154&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abda154",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5abda154')) {
      api.createRecord('5abda154', component.options)
    } else {
      api.reload('5abda154', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5abda154&scoped=true", function () {
      api.rerender('5abda154', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/stock/transfer/virtual/index.vue"
export default component.exports